module.exports = __webpack_public_path__ + "img/maintenance-img.e6d2f432.png";